module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (Object.keys(_vm.data).length > 0 && _vm.$store.state.windowWidth <= 767) ? _c('div', {
    staticClass: "w5-opers-button-for-mobile"
  }, [('update' in _vm.data) ? _c('div', {
    staticClass: "w5-opers-button-curd-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('update')
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "pencil-alt"
    }
  })], 1) : _vm._e(), _vm._v(" "), ('delete' in _vm.data) ? _c('div', {
    staticClass: "w5-opers-button-curd-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('delete')
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "color-red",
    attrs: {
      "icon": "trash-alt"
    }
  })], 1) : _vm._e()]) : (Object.keys(_vm.data).length > 0 && _vm.$store.state.windowWidth > 767) ? _c('div', {
    attrs: {
      "data-index": _vm.index
    }
  }, [(_vm.canShowCrudButton && 'update' in _vm.data) ? _c('span', {
    staticClass: "w5-dropdown-menu-item w5-opers-button-one-btn",
    attrs: {
      "title": _vm._f("ftc")(_vm.data['update']['title'] ? _vm.data['update']['title'] : 'main/update')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('update')
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "pencil-alt"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canShowCrudButton && 'delete' in _vm.data) ? _c('span', {
    staticClass: "w5-dropdown-menu-item w5-opers-button-one-btn",
    attrs: {
      "title": _vm._f("ftc")(_vm.data['delete']['title'] ? _vm.data['delete']['title'] : 'main/delete')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clickOper('delete')
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "color-red",
    attrs: {
      "icon": "trash-alt"
    }
  })], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-394c84f6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/oneoper.vue
// module id = 506
// module chunks = 0